import lambCase from '../../assets/images/banners/lamb_case.png';
import lambCaseBg from '../../assets/images/banners/lamb_case_bg.png';
import lambCaseDefaultBg from '../../assets/images/banners/lamb_case_dec.png';

export const banners = [
	{
		caseId: 'bronze_case',
		background: lambCaseBg,
		dec: lambCaseDefaultBg,
		image: lambCase,
		title: 'LAMBORGHINI',
		subtitle: 'ЛИМИТИРОВАННЫЙ КЕЙС',
		description:
			'Успей забрать уникальную Lamborghini Countach ‘79 и покори всех своей эстетикой 70х годов, на просторах Лос-Сантоса',
		count: 33,
		totalCount: 100,
		promotionEndsAt: Date.now() + 5 * 24 * 60 * 60 * 1000,
	},
];
